import { createSlice } from "@reduxjs/toolkit";
import { fetchApprovedCustomerList } from "./CustomerApprovedThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    filterType: "All",
  },
};

const customerApprovedSlice = createSlice({
  name: "customerApproved",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApprovedCustomerList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchApprovedCustomerList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchApprovedCustomerList.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = customerApprovedSlice.actions;
export default customerApprovedSlice.reducer;
